<div class="row d-md-flex flex-xs-column heading-container">
    <h1 class="main-title col-12" [innerHTML]="collection.title"></h1>
    <div
        class="col-xs-12 central-section"
        [ngClass]="{ 'no-description-central-section': !collection.hasFeaturedAssets() }"
    >
        <div class="share-collection-section align-items-start mb-2">
            <app-link-button
                [tooltip]="(isInPreviewMode$ | async) ? '' : 'Share to Google Classroom.'"
                class="gtm-share-google-classroom selenium-share-google-classroom ms-4 me-4"
                label="Share to Google Classroom"
                [attr.data-gtmlabel]="collection.title + ' Premium Collection'"
                [classList]="'gc-collection-icon'"
                [ngClass]="{ 'preview-color': isInPreviewMode$ | async }"
                [disable]="isInPreviewMode$ | async"
                (trigger)="shareWithGoogleClassroom()"
            >
                <img [src]="googleClassroomImage" class="mb-1 gc-icon" alt="Google Classroom" />
            </app-link-button>
            <app-link-button
                [tooltip]="
                    (isInPreviewMode$ | async) ? '' : 'Share to Remind, email, Facebook and more.'
                "
                class="gtm-collection-open-share selenium-share ms-4 me-4 height-icon"
                label="Social Share"
                icon="Share-Social"
                [classList]="'height-img'"
                [ngClass]="{ 'preview-color': isInPreviewMode$ | async }"
                [disable]="isInPreviewMode$ | async"
                [attr.data-gtmlabel]="collection.title + ' Premium Collection'"
                (trigger)="openShareModal()"
            >
            </app-link-button>
            <app-favorite-button
                [learningObjectId]="collection.loId"
                class="ms-4 me-4 gtm-collection-favorite selenium-favorite height-icon"
                [loggedoutTooltip]="
                    (isInPreviewMode$ | async) ? '' : 'Sign in to save this collection for later.'
                "
                [loggedinTooltip]="
                    (isInPreviewMode$ | async) ? '' : 'Save this collection for later.'
                "
                [classList]="'height-img'"
                [gtmLabel]="collection.title + ' Premium Collection'"
                [ngClass]="{ 'preview-color': isInPreviewMode$ | async }"
                [disable]="isInPreviewMode$ | async"
            >
            </app-favorite-button>
        </div>
        <div class="row-auto main-description">
            <div class="col-12 mt-xl-6">
                <div
                    class="long-desc"
                    [innerHtml]="collection.description | bypassSecurity: 'html'"
                ></div>
            </div>
        </div>
    </div>
    <app-collection-description
        [displayShortDescription]="isShortDescDisplayed"
        [featuredAsset]="collection.featuredAsset"
        [styles]="collection.style"
        *ngIf="hasFeaturedAsset()"
        class="col-xs-12 d-none d-md-block collection-description"
    >
    </app-collection-description>
    <app-preloader *ngIf="!hasCollectionLoaded(); else emptyMessage"></app-preloader>
    <ng-template #emptyMessage>
        <div
            class="w-100 fw-bold mt-7 mb-3 text-center"
            *ngIf="
                !isParenCollectionWithChildren &&
                collection.totalResources === null &&
                !isLoading &&
                isStudent
            "
        >
            No resources available
            <span *ngIf="isStudent && selectedGrade !== 'All grades'">
                for {{ selectedGrade }}. Filter by All Grades to see the full collection.
            </span>
        </div>
    </ng-template>
</div>
